import { render, staticRenderFns } from "./LoanCollateralAssetOtherFieldsEdit.vue?vue&type=template&id=09880fce&scoped=true&lang=pug&"
import script from "./LoanCollateralAssetOtherFieldsEdit.vue?vue&type=script&lang=js&"
export * from "./LoanCollateralAssetOtherFieldsEdit.vue?vue&type=script&lang=js&"
import style0 from "./LoanCollateralAssetOtherFieldsEdit.vue?vue&type=style&index=0&id=09880fce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09880fce",
  null
  
)

/* custom blocks */
import block0 from "./LoanCollateralAssetOtherFieldsEdit.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports